
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.398 13.056c3.103.922 2.571 3.202 2.562 4.73h-7.74c-.278-.925-.966-1.789-2.608-2.274l-.519-.158c-2.172-.64-3.335-.985-3.64-1.678-.074-.25-.051-.527.673-.794 2.328-.685 3.508-1.044 3.786-1.927h.147a1.211 1.211 0 01-.114-.113c-1.15-1.123-2.03-3.314-2.03-5.084 0-2.502 1.893-4.146 3.683-4.146 1.789 0 3.59 1.776 3.59 4.281 0 1.77-.978 3.892-2.179 4.978.248 1.021 1.597 1.356 4.39 2.185z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M32.054 23.535H8.01c-.015-.243-.03-.487-.059-.774-.074-.962-.148-1.952.118-2.857.325-1.061 1.167-1.994 3.115-2.57l.754-.243c3.426-.99 5.258-1.55 5.863-2.856l.193-.33-.015-.416a.546.546 0 01-.133-.13 7.23 7.23 0 01-.606-.687c-1.329-1.71-2.274-4.35-2.274-6.53 0-2.786 2.039-5.742 5.08-5.742 2.378 0 4.934 2.383 4.934 5.942 0 2.269-1.167 5.08-2.762 6.731-.104.116-.222.215-.325.316l-.192.173.06.26c.413 1.634 2.274 2.194 6.01 3.27l.768.244c1.935.575 2.85 1.523 3.25 2.57h.014c.37 1.018.324 2.125.28 3.157-.014.156-.014.329-.029.473z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M2.601 13.056c-3.105.922-2.569 3.202-2.561 4.73h7.737c.28-.925.965-1.789 2.61-2.274l.518-.158c2.174-.64 3.338-.985 3.64-1.678-.083-.275.068-.688-.674-.794-2.327-.685-3.506-1.044-3.784-1.927h-.145c.039-.036.078-.07.113-.113 1.15-1.123 2.03-3.314 2.03-5.084 0-2.502-1.891-4.146-3.682-4.146-1.792 0-3.59 1.776-3.59 4.281 0 1.77.974 3.892 2.174 4.978-.246 1.021-1.597 1.356-4.386 2.185z","fill":"currentColor"}})])
          )
        }
      }
    